import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import BackgroundImage from 'gatsby-background-image';
import ReactMarkdown from 'react-markdown';
import SbEditable from 'storyblok-react';

import Navi from '../Navi/index.js';
import Footer from '../Footer/index.js';
import { fluidImage } from '../../utils/gatsbyImageTransform';
import './job-post.scss';

const JobPost = (props) => {
  const naviBlok = { theme: 'dark', phone_number: '18884651784' };

  let optimizedFluidImage = fluidImage(
    'https://a.storyblok.com/f/89720/1277x960/e465d797e3/terrace_solar_house_darkened.jpg',
    {
      maxWidth: 2160,
    }
  );

  const headerClasses = ['header'];
  headerClasses.push('theme-dark');

  const jobTitleUrlSafe = encodeURIComponent(props.blok.title);
  const { visible } = props.blok;
  const isInEditor =
    typeof window !== `undefined` ? window.location.pathname.startsWith('/editor') : false;

  useEffect(() => {
    if (!visible && typeof window !== undefined && !isInEditor) {
      window.location.href = '/jobs';
    }
  }, [visible]);

  return (
    <SbEditable content={props.blok}>
      <Helmet>
        <title>{props.blok.title || ''} - Swell Energy Jobs</title>
        <meta name="description" content="Work at Swell" />
        <meta property="og:title" content={props.blok.title} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="job-post">
        <Navi blok={naviBlok}></Navi>
        <Wrapper fluid={optimizedFluidImage} className={headerClasses.join(' ')}>
          <h1>{props.blok.title}</h1>
          <PostInfo>
            <div>
              {props.blok.category} - {props.blok.type}
            </div>
          </PostInfo>
        </Wrapper>
        <div className="body">
          <h2>Job Description</h2>
          <ReactMarkdown children={props.blok.description} />
          <h2>Responsibilities</h2>
          <ReactMarkdown children={props.blok.responsibilities} />
          <h2>Requirements</h2>
          <ReactMarkdown children={props.blok.requirements} />
          <ApplyContainer>
            <span>
              Interested? Send your resume to{' '}
              <a href={`mailto:careers@swellenergy.com?subject=${jobTitleUrlSafe}`}>
                careers@swellenergy.com
              </a>
            </span>
          </ApplyContainer>
        </div>
        <Footer blok={{}}></Footer>
      </div>
    </SbEditable>
  );
};

export default JobPost;

const Wrapper = styled((props) => <BackgroundImage {...props} />)`
  width: 100%;
  min-height: 50vh;
  background-position: center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.5);
  background-blend-mode: overlay;
  display: flex;
  flex-direction: column;
  padding-top: 8rem;
  padding-bottom: 1rem;
`;

const PostInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ApplyContainer = styled.div`
  display: block;
  background-color: #2a96f4;
  color: #ffffff;
  padding: 1rem;
  margin-top: 3rem;
  text-align: center;

  a {
    color: #ffffff;
    text-decoration: underline;
  }
`;
